<template>
  <div>
    <v-alert
      class="elevation-2 body-2 py-6"
    >
      <h3 class="mb-2">
        Something you’d like to change?
      </h3>
      <p class="caption mb-8">
        If any of the information you’ve given us isn’t correct, your {{ productName }} insurance may not be valid and the insurer could refuse to pay any claim you make.
        Ouch! Be sure you’re insured.
      </p>
      <div class="text-center">
        <v-btn
          rounded
          depressed
          outlined
          color="primary"
          class="pa-4 outlined-2"
          @click.prevent="handleMakeQuoteChanges"
        >
          <v-icon
            color="primary"
            class="ml-1"
            small
          >
            mdi-open-in-new
          </v-icon>
          <span
            class="primary--text"
          >
            Make changes to my quote info
          </span>
        </v-btn>
      </div>
    </v-alert>
  </div>
</template>

<script>
import {
  inject,
} from '@vue/composition-api';

export default {
  name: 'change-quote-info',
  inject: ['productName'],
  methods: {
    handleMakeQuoteChanges () {
      this.internalTrackerResultsPage('makeChangesToMyQuoteInfo', true);
      this.$emit('go-to-form');
    },
  },
  setup () {
    const internalTrackers = inject('internalTrackers');

    return { ...internalTrackers };
  },
};
</script>
